import { $host, handleError, handleResponse } from "./index";

export const paragraphThemes = async (paragraph_id) => {
    if (!paragraph_id) throw new Error('Не указан paragraph_id');
    try {
        const res = await $host.get(`/api/students/paragraphs/themes/${paragraph_id}`, { withCredentials: true });
        return handleResponse(res);
    } catch (error) {
        handleError(error);
    }
};

export const paragraphThemeByID = async (theme_id) => {
    if (!theme_id) throw new Error('Не указан paragraph_id');
    try {
        const res = await $host.get(`/api/students/themes/${theme_id}`, { withCredentials: true });
        return handleResponse(res);
    } catch (error) {
        handleError(error);
    }
};